import { createAction } from 'react-async-client';

import {
    SET_WORKSHEET_LIST_FILTERS,
    SET_WORKSHEET_LIST_SELECTED,
    SET_WORKSHEET_LIST_SORT,
    SET_WORKSHEET_LIST_PAGINATION,
    SET_WORKSHEET_LIST_COLUMN_WIDTH
} from 'constants/actionTypes';

export const setWorksheetListFilters = createAction(SET_WORKSHEET_LIST_FILTERS);
export const setWorksheetListSelected = createAction(SET_WORKSHEET_LIST_SELECTED);
export const setWorksheetListSort = createAction(SET_WORKSHEET_LIST_SORT);
export const setWorksheetListPagination = createAction(SET_WORKSHEET_LIST_PAGINATION);
export const setWorksheetListColumnWidth = createAction(SET_WORKSHEET_LIST_COLUMN_WIDTH);
